/* RESPONSIBLE TEAM: team-ai-agent-2 */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import { taskFor } from 'ember-concurrency-ts';

class StandaloneAttributesRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare reportingMetrics: ReportingMetrics;

  reactEnabled() {
    return true;
  }

  buildRouteInfoMetadata() {
    let metadata = { react: this.reactEnabled() };
    return metadata;
  }

  async beforeModel() {
    await taskFor(this.reportingMetrics.setup).perform();
  }

  get titleToken() {
    return this.intl.t('standalone.navbar.categories');
  }
}

export default ReactRoute(StandaloneAttributesRoute, { overrideRenderTemplate: false });
